import React, { useState } from "react";
import GoogleWatch from "@assets/images/GoogleWatch.svg";
import GoogleHeart from "@assets/images/google-fit-heart.svg";
import BackImg from "@assets/images/stepsBack.jpg";
import ReactModal from "react-modal";
import { connectWithGoogle } from "api/authService";
import { useGoogleFitLogin } from "@utils/useGoogleFitLogin";
import { toast } from "react-toastify";
import { ConnectGoogle } from "./ConnectGoogle";

const GoogleFirstPopup = ({ showModal, setShowModal }) => {
  const stored = localStorage.getItem("is_google_fit_connect");
  const initialValue = stored === "true";
  const [googleFitConnect, setGoogleFitConnect] = useState(initialValue);
  const [connectingGoogleFit, setConnectingGoogleFit] = useState(false);
  const [open, setOpen] = useState(false);
  const handleSuccess = async (codeResponse) => {
    setOpen(false);
    try {
      setConnectingGoogleFit(true);
      await connectWithGoogle(codeResponse?.code);
      setGoogleFitConnect(true);
      localStorage.setItem("is_google_fit_connect", "true");
      setConnectingGoogleFit(false);

      toast.info("Google Fit connected successfully!");
      setShowModal(false)
    } catch (error) {
      console.error("❌ Error sending code to backend:", error);
      toast.error(
          "Google login failed. Please try again."
      );
      setConnectingGoogleFit(false);
    }
  };
  const loginGoogleFit = useGoogleFitLogin(handleSuccess);
  const handleOpenGoogle = async () => {
    try {
      loginGoogleFit();
    } catch (error) {
      console.error("Error in google authentication", error);
    }
  };
 return (
    <ReactModal
      isOpen={showModal}
      // onRequestClose={() => setShowModal(false)}
      className="relative w-[95vw] max-w-[531px] min-h-[400px] max-h-[90vh] font-[Lato] outline-none overflow-hidden rounded-[16px]"
      overlayClassName="fixed inset-0 flex items-center justify-center backdrop-blur-sm bg-black/50 z-50 p-4"
      style={{
        content: {
          // Responsive height that works with zoom
          height: 'auto',
          minHeight: '400px',
          maxHeight: '90vh',
          // Center the modal
          margin: 'auto',
          // Add scroll for content overflow
          overflowY: 'auto',
        }
      }}
    >
      <div
        className="min-h-[400px] h-auto p-6 md:p-10 bg-cover flex flex-col justify-center"
        style={{ 
          backgroundImage: `url(${BackImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        {/* Content wrapper with responsive padding */}
        <div className="flex flex-col items-center text-center h-full">
          <div className="w-full max-w-[300px] mx-auto">
            <img 
              src={GoogleWatch} 
              alt="Watch Image" 
              className="w-full h-auto max-h-[200px] object-contain" 
            />
          </div>
          
          <div className="mt-4 md:mt-6 w-full">
            <h1 className="text-[18px] md:text-[20px] font-[600] text-white font-[Lato]">
              Set Up Your Activity Tracking
            </h1>
            <p className="text-[14px] md:text-[16px] font-[Lato] font-[400] mt-2 text-white">
              Enable syncing to see your activity progress here.
            </p>
          </div>

          {/* Buttons container with responsive layout */}
          <div className="mt-6 md:mt-8 w-full flex flex-col sm:flex-row justify-center items-center gap-3">
            <button 
              onClick={() => setShowModal(false)}
              className="w-full sm:w-auto min-w-[140px] text-[#4CDBFF] bg-white py-3 px-6 rounded-full hover:opacity-90 transition-opacity font-medium"
            >
              Maybe Later
            </button>
            <button
              className="w-full sm:w-auto min-w-[200px] bg-[#64DDFF] py-3 px-6 text-white rounded-full hover:opacity-90 transition-opacity font-medium flex items-center justify-center gap-2"
              onClick={() => setOpen(true)}
              disabled={connectingGoogleFit}
            >
              {connectingGoogleFit ? "Connecting..." : "Connect via Google Fit"}
              {!connectingGoogleFit && (
                <img src={GoogleHeart} alt="GoogleHeart" className="w-5 h-5" />
              )}
            </button>
          </div>
        </div>

        {/* Loading overlay - fixed positioning */}
        {connectingGoogleFit && (
          <div className="absolute inset-0 flex items-center justify-center z-50 bg-black/70 rounded-[16px]">
            <div className="flex flex-col items-center p-4">
              <svg
                className="animate-spin h-10 w-10 md:h-12 md:w-12 text-white mb-3"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              <p className="text-white text-base md:text-lg text-center">
                Connecting to Google Fit...
              </p>
            </div>
          </div>
        )}
        
        {open && (
          <ConnectGoogle
            open={open}
            setOpen={setOpen}
            handleOpenGoogle={handleOpenGoogle}
            loading={connectingGoogleFit}
          />
        )}
      </div>
    </ReactModal>
  );
};

export default GoogleFirstPopup;
